export default "__VITE_ASSET__C3yT173x__"